import { createI18n } from "@mbits/mray-react-common";
import translation_en from "./en/translation.json";
import translation_de from "./de/translation.json";

export default createI18n({ en: translation_en, de: translation_de });
